import { toI18n } from 'util/i18n';

import { JobData, JobFormStage } from './types';

export const initialJobData: JobData = {
  role_id: 0,
  job_title: '',
  job_role: '',
  job_description: '',
  prompt: '',
  job_requirements: {
    type: '',
    days: [],
    shifts: [],
    years_of_experience: '',
  },
  job_pay: {
    range: { min: 0, max: 0, frequency: 'hourly' },
    tips: { amount: 0, time_range: '' },
    benefits: '',
  },
  status: '',
  more_info: '',
  syndication_settings: {
    partner_toggles: {
      indeed: true,
      walk_in: true,
      google_jobs: true,
      your_network: true,
      zip_recruiter: true,
    },
  },
};

export const DAY_NUMBER_MAPPING: Record<string, string> = {
  0: toI18n('hiring.v2.job_request.job_description_page.job_details.monday'),
  1: toI18n('hiring.v2.job_request.job_description_page.job_details.tuesday'),
  2: toI18n('hiring.v2.job_request.job_description_page.job_details.wednesday'),
  3: toI18n('hiring.v2.job_request.job_description_page.job_details.thursday'),
  4: toI18n('hiring.v2.job_request.job_description_page.job_details.friday'),
  5: toI18n('hiring.v2.job_request.job_description_page.job_details.saturday'),
  6: toI18n('hiring.v2.job_request.job_description_page.job_details.sunday'),
};

export const DAY_NUMBER_MAPPING_REVERSE: Record<string, string> = {
  monday: '0',
  tuesday: '1',
  wednesday: '2',
  thursday: '3',
  friday: '4',
  saturday: '5',
  sunday: '6',
};

export const STAGE_NUMBER_MAPPING: Record<JobFormStage, number> = {
  job_description: 1,
  screener: 2,
  review_and_post: 3,
};

export const EEO_QUESTIONS = [
  toI18n('hiring.v2.job_request.eeo_questions.q1'),
  toI18n('hiring.v2.job_request.eeo_questions.q2'),
  toI18n('hiring.v2.job_request.eeo_questions.q3'),
  toI18n('hiring.v2.job_request.eeo_questions.q4'),
  toI18n('hiring.v2.job_request.eeo_questions.q5'),
  toI18n('hiring.v2.job_request.eeo_questions.q6'),
  toI18n('hiring.v2.job_request.eeo_questions.q7'),
  toI18n('hiring.v2.job_request.eeo_questions.q8'),
];

export const MINIMUM_SCREENER_QUESTIONS = 3;
